import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrizesRoutingModule } from './prizes-routing.module';
import { AllPrizesComponent } from './all-prizes/all-prizes.component';
import { AddPrizeComponent } from './add-prize/add-prize.component';
import { EditPrizeComponent } from './edit-prize/edit-prize.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ArchwizardModule } from 'angular-archwizard';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { MediaManagerModule } from 'src/app/components/media-manager/media-manager.module';


@NgModule({
  declarations: [AllPrizesComponent, AddPrizeComponent, EditPrizeComponent],
  imports: [
    CommonModule,
    PrizesRoutingModule,
    ReactiveFormsModule,
    ArchwizardModule,
    SharedModule,
    MediaManagerModule
  ]
})
export class PrizesModule { }
